




import { Component, Vue, Prop } from 'vue-property-decorator';
import { DashboardPageFieldType, FieldValueType, IndividualDataTableUserData } from '@/models/hcad/shared/dashboard';
import { UserInfoAndMetrics } from '../../../models/hcad/shared/queries';
import { fieldViewerComponents, FieldViewerContext } from '../../../utils/typed-configs';

@Component
export default class UserNameRenderer extends Vue
{
    @Prop({type: Number, required: true})
    type!: DashboardPageFieldType;

    @Prop({required: true})
    value!: FieldValueType;

    @Prop({type: Object, required: true})
    context!: UserInfoAndMetrics<IndividualDataTableUserData>;
}

function toString(fieldIdx: number, fieldType: (DashboardPageFieldType | string), a: FieldViewerContext)
{
    return a[1].user.fullName;
}

function sort(fieldIdx: number, fieldType: (DashboardPageFieldType | string), a: FieldViewerContext, b: FieldViewerContext)
{
    const aval = a[1].user.fullName;
    const bval = b[1].user.fullName;
    return -aval.localeCompare(bval);
}

fieldViewerComponents
    .registerComponent(DashboardPageFieldType.UserName, UserNameRenderer)
    .registerDataFactory(DashboardPageFieldType.UserName, () => ({ toString, sort }));

